/* Mint-Import · modal + ngăn kéo claim. Màu chỉ var(--…). */
.form { display: flex; flex-direction: column; gap: 14px; }
.lab { margin-bottom: 6px; color: var(--tx2); font-size: 12px; font-weight: var(--fw-label); }
.route { padding: 12px 14px; border-radius: 12px; background: var(--sub); }
.routeK { margin-bottom: 8px; color: var(--tx2); font-size: 12px; font-weight: var(--fw-label); }
.step { display: flex; align-items: center; gap: 10px; min-height: 30px; }
.stepI { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; flex-shrink: 0; border-radius: 7px; font-size: 11px; font-weight: 600; }
.sPri { background: var(--pri-bg); color: var(--link); }
.sWarn { background: var(--warn-bg); color: var(--warn); }
.sMute { background: var(--ctl); color: var(--tx2); }
.stepK { flex: 1; min-width: 0; }
.stepV { color: var(--lb); font-size: 12px; text-align: right; }
.grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 14px; align-content: start; }
.span2 { grid-column: span 2; }
.files { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
.file { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; height: 76px; border: 1px dashed var(--bd); border-radius: 12px; background: var(--sub); color: var(--tx2); font: inherit; cursor: pointer; }
.file b { color: var(--tx); font-weight: var(--fw-label); }
.file:focus-visible { outline: 2px solid var(--pri); outline-offset: 1px; }
.note { padding: 12px 14px; border-radius: 12px; background: var(--sub); color: var(--tx2); }
.footNote { flex: 1; color: var(--lb); font-size: 12px; }
